import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';
import type { PaymentMethodResponse } from './types';

export const getPaymentMethodsSubscriptionByCustomersFn = async () => {
  const response = await httpClient.get<PaymentMethodResponse>(
    apiRoutes.payment.get_list_payment_methods_subscription
  );

  if (response.data?.status === 'success') {
    return response.data.data;
  }

  return [];
};
